import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="app--participant-form"
export default class extends Controller {

	static targets = [
		'studentSection',
	]

	static values = {
		'studentParticipantTypeId': String
	}

	connect() {
		this.updateFormSections()
	}

	updateFormSections(_event) {
		if (this.isStudentParticipantType()) {
			this.studentSectionTarget.classList.remove('d-none')
			this.studentSectionTarget.querySelectorAll('input, select')
				.forEach( (element) => element.disabled = false )
		} else {
			this.studentSectionTarget.classList.add('d-none')
			this.studentSectionTarget.querySelectorAll('input, select')
				.forEach( (element) => element.disabled = true )
		}
	}

	isStudentParticipantType() {
		const studentParticipantTypeInput = this.element
			.querySelector(`input[name="participant[participant_types_attributes][][id]"][value="${this.studentParticipantTypeIdValue}"]`)

		if (studentParticipantTypeInput.checked) { return true }
		return false
	}
}
